@if(user){
<div class="tw-flex tw-items-center tw-gap-2 surface-light tw-rounded-md tw-p-2 tw-leading-none">
  <button class="p-link layout-topbar-button" (click)="menu.toggle($event)">
    <div class="tw-flex tw-gap-2 tw-items-center">
      @if(user.Profile.ImageUrl) {
      <img [src]="user.Profile.ImageUrl" alt="Image" class="tw-w-6 md:tw-w-8 tw-rounded-full">
      } @else {
      <i class="pi pi-user"></i>
      }
      <strong class="tw-hidden lg:tw-inline">{{user.Profile.Name||user.Identity.Email||(user.Identity.PhoneNumber|phone)||user.Id}}</strong>
    </div>
  </button>
</div>
<p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" styleClass="tw-w-screen md:tw-w-auto"></p-menu>

<p-dialog header="Add balance" [(visible)]="addBalanceDialog" [modal]="true" appendTo="body">
  <div class="tw-flex tw-flex-col tw-gap-4">
    <label htmlFor="phone">Enter the amount you want to add to your balance</label>
    <p-inputGroup>
      <p-inputNumber [(ngModel)]="balanceAmount" [min]="1" [max]="1000" currency="GBP" mode="currency"></p-inputNumber>
      <button type="submit" pButton [loading]="gettingHash" (click)="getExtendedHash()" icon="pi pi-check"
        [disabled]="!(balanceAmount>0)"></button>
    </p-inputGroup>
  </div>
  @if(extendedHash){
  <form ngNoForm class="tw-flex tw-flex-col tw-gap-2" method="post" [action]="extendedHash.Url">
    <input type="hidden" *ngFor="let item of extendedHash.Data|keyvalue" name="{{item.key}}" [value]="item.value" />
    <div><strong>Amount to add:</strong> {{extendedHash.Data['chargetotal']|currency:'&pound;'}}</div>
    <div class="p-fluid">
      <button type="submit" pButton [disabled]="+extendedHash.Data['chargetotal']!=balanceAmount"
        label="Pay & Add Balance" class="p-button"></button>
    </div>
  </form>
  <div class="tw-p-4 tw-flex tw-justify-center">
    <brt-payment-logos></brt-payment-logos>
  </div>
  }
</p-dialog>
} @else {
<brt-login></brt-login>
}